var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "a-spin",
    { attrs: { spinning: _vm.formOption.busy } },
    [
      _c(
        "a-form",
        {
          ref: "form",
          attrs: {
            form: _vm.form,
            "label-col": { span: 8 },
            "wrapper-col": { span: 16 },
          },
        },
        [
          _c(
            "a-row",
            { attrs: { gutter: 24 } },
            [
              _c(
                "a-col",
                { attrs: { span: 20 } },
                [
                  _c(
                    "a-form-item",
                    { attrs: { label: "活动名称" } },
                    [
                      _c("a-input", {
                        directives: [
                          {
                            name: "decorator",
                            rawName: "v-decorator",
                            value: ["activityName"],
                            expression: "['activityName']",
                          },
                        ],
                        attrs: {
                          placeholder: "请输入活动名称",
                          disabled: _vm.showAct,
                        },
                      }),
                    ],
                    1
                  ),
                ],
                1
              ),
            ],
            1
          ),
          _c(
            "a-row",
            { attrs: { gutter: 24 } },
            [
              _c(
                "a-col",
                { attrs: { span: 20 } },
                [
                  _c(
                    "a-form-item",
                    { staticClass: "time-box", attrs: { label: "活动时间" } },
                    [
                      _c("a-date-picker", {
                        directives: [
                          {
                            name: "decorator",
                            rawName: "v-decorator",
                            value: ["activityStartTime"],
                            expression: "['activityStartTime']",
                          },
                        ],
                        attrs: {
                          "disabled-date": _vm.disabledStartDate,
                          "show-time": "",
                          valueFormat: "YYYY-MM-DD HH:mm:ss",
                          placeholder: "请选择活动开始时间",
                          disabled: _vm.showAct,
                        },
                        on: { change: _vm.startPanelChange },
                      }),
                      _c("a-date-picker", {
                        directives: [
                          {
                            name: "decorator",
                            rawName: "v-decorator",
                            value: ["activityEndTime"],
                            expression: "['activityEndTime']",
                          },
                        ],
                        attrs: {
                          "disabled-date": _vm.disabledEndDate,
                          "show-time": "",
                          valueFormat: "YYYY-MM-DD HH:mm:ss",
                          placeholder: "请选择活动结束时间",
                          disabled: _vm.showAct,
                        },
                        on: { change: _vm.endPanelChange },
                      }),
                    ],
                    1
                  ),
                ],
                1
              ),
            ],
            1
          ),
          _c(
            "a-row",
            { attrs: { gutter: 24 } },
            [
              _c(
                "a-col",
                { attrs: { span: 20 } },
                [
                  _c(
                    "a-form-item",
                    { attrs: { label: "活动类型" } },
                    [
                      _c("a-input", {
                        directives: [
                          {
                            name: "decorator",
                            rawName: "v-decorator",
                            value: ["activityTypeName"],
                            expression: "['activityTypeName']",
                          },
                        ],
                        attrs: {
                          placeholder: "请输入活动类型",
                          disabled: _vm.showAct,
                        },
                      }),
                    ],
                    1
                  ),
                ],
                1
              ),
            ],
            1
          ),
          _c(
            "a-row",
            { attrs: { gutter: 24 } },
            [
              _c(
                "a-col",
                { attrs: { span: 20 } },
                [
                  _c(
                    "a-form-item",
                    { attrs: { label: "车型代码" } },
                    [
                      _c("a-input", {
                        directives: [
                          {
                            name: "decorator",
                            rawName: "v-decorator",
                            value: ["carNumber"],
                            expression: "['carNumber']",
                          },
                        ],
                        attrs: {
                          placeholder: "请输入车型代码",
                          disabled: _vm.showAct,
                          maxLength: 20,
                        },
                      }),
                    ],
                    1
                  ),
                ],
                1
              ),
            ],
            1
          ),
          _c(
            "a-row",
            { attrs: { gutter: 24 } },
            [
              _c(
                "a-col",
                { attrs: { span: 20 } },
                [
                  _c(
                    "a-form-item",
                    { attrs: { label: "活动地点" } },
                    [
                      _c("a-input", {
                        directives: [
                          {
                            name: "decorator",
                            rawName: "v-decorator",
                            value: ["activityPlace"],
                            expression: "['activityPlace']",
                          },
                        ],
                        attrs: {
                          placeholder: "请输入活动地点",
                          disabled: _vm.showAct,
                        },
                      }),
                    ],
                    1
                  ),
                ],
                1
              ),
            ],
            1
          ),
          _c(
            "a-row",
            { attrs: { gutter: 24 } },
            [
              _c(
                "a-col",
                { attrs: { span: 20 } },
                [
                  _c(
                    "a-form-item",
                    { attrs: { label: "客户窝子" } },
                    [
                      _c("a-input", {
                        directives: [
                          {
                            name: "decorator",
                            rawName: "v-decorator",
                            value: ["activityWoZi"],
                            expression: "['activityWoZi']",
                          },
                        ],
                        attrs: {
                          placeholder: "请输入客户窝子",
                          disabled: _vm.showAct,
                        },
                      }),
                    ],
                    1
                  ),
                ],
                1
              ),
            ],
            1
          ),
          _c("a-divider"),
          _c(
            "a-row",
            { attrs: { gutter: 24 } },
            [
              _c(
                "a-col",
                { attrs: { span: 20 } },
                [
                  _c(
                    "a-form-item",
                    {
                      staticClass: "time-box",
                      attrs: { label: "活动实际时间" },
                    },
                    [
                      _c("a-date-picker", {
                        directives: [
                          {
                            name: "decorator",
                            rawName: "v-decorator",
                            value: [
                              "acturalStartTime",
                              {
                                rules: [
                                  {
                                    false: true,
                                    message: "请选择活动实际开始时间",
                                  },
                                ],
                              },
                            ],
                            expression:
                              "['acturalStartTime', { rules: [{ false: true, message: '请选择活动实际开始时间' }] }]",
                          },
                        ],
                        attrs: {
                          "show-time": "",
                          valueFormat: "YYYY-MM-DD HH:mm:ss",
                          placeholder: "请选择实际开始时间",
                          disabled: _vm.show,
                        },
                        on: { change: _vm.startPanelChange },
                      }),
                      _c("a-date-picker", {
                        directives: [
                          {
                            name: "decorator",
                            rawName: "v-decorator",
                            value: [
                              "acturalEndTime",
                              {
                                rules: [
                                  {
                                    false: true,
                                    message: "请选择活动实际结束时间",
                                  },
                                ],
                              },
                            ],
                            expression:
                              "['acturalEndTime', { rules: [{ false: true, message: '请选择活动实际结束时间' }] }]",
                          },
                        ],
                        attrs: {
                          "show-time": "",
                          valueFormat: "YYYY-MM-DD HH:mm:ss",
                          placeholder: "请选择实际结束时间",
                          disabled: _vm.show,
                        },
                        on: { change: _vm.endPanelChange },
                      }),
                    ],
                    1
                  ),
                ],
                1
              ),
            ],
            1
          ),
          _c(
            "a-row",
            { attrs: { gutter: 24 } },
            [
              _c(
                "a-col",
                { attrs: { span: 20 } },
                [
                  _c(
                    "a-form-item",
                    { attrs: { label: "现场订车" } },
                    [
                      _c("a-input-number", {
                        directives: [
                          {
                            name: "decorator",
                            rawName: "v-decorator",
                            value: ["orderCarCount", _vm.rules.orderCarCount],
                            expression:
                              "['orderCarCount',rules.orderCarCount ]",
                          },
                        ],
                        attrs: {
                          placeholder: "请输入现场订车",
                          readonly: "",
                          disabled: "",
                        },
                      }),
                    ],
                    1
                  ),
                ],
                1
              ),
            ],
            1
          ),
          _c(
            "a-row",
            { attrs: { gutter: 24 } },
            [
              _c(
                "a-col",
                { attrs: { span: 20 } },
                [
                  _c(
                    "a-form-item",
                    { attrs: { label: "合同收据" } },
                    [
                      _c(
                        "a-upload",
                        {
                          attrs: {
                            action: _vm.action,
                            headers: _vm.headers,
                            "list-type": "picture-card",
                            fileList: _vm.myAccountFileList,
                            multiple: true,
                            remove: _vm.removeAccountFile,
                          },
                          on: { change: _vm.handleChange },
                        },
                        [
                          _c(
                            "div",
                            [
                              _c("a-icon", { attrs: { type: "plus" } }),
                              _c("div", { staticClass: "ant-upload-text" }, [
                                _vm._v(" 上传 "),
                              ]),
                            ],
                            1
                          ),
                        ]
                      ),
                    ],
                    1
                  ),
                ],
                1
              ),
            ],
            1
          ),
          _c(
            "a-row",
            { attrs: { gutter: 24 } },
            [
              _c(
                "a-col",
                { attrs: { span: 20 } },
                [
                  _c(
                    "a-form-item",
                    { attrs: { label: "实际费用" } },
                    [
                      _c("a-input-number", {
                        directives: [
                          {
                            name: "decorator",
                            rawName: "v-decorator",
                            value: [
                              "activitySumCharge",
                              _vm.rules.activitySumCharge,
                            ],
                            expression:
                              "['activitySumCharge',rules.activitySumCharge ]",
                          },
                        ],
                        attrs: {
                          placeholder: "请输入实际费用",
                          readonly: "",
                          disabled: "",
                        },
                      }),
                    ],
                    1
                  ),
                ],
                1
              ),
            ],
            1
          ),
          _c(
            "a-row",
            { attrs: { gutter: 24 } },
            [
              _c(
                "a-col",
                { attrs: { span: 20 } },
                [
                  _c(
                    "a-form-item",
                    { attrs: { label: "活动说明" } },
                    [
                      _c("a-textarea", {
                        directives: [
                          {
                            name: "decorator",
                            rawName: "v-decorator",
                            value: ["activityDesc", _vm.rules.activityDesc],
                            expression: "['activityDesc',rules.activityDesc ]",
                          },
                        ],
                        attrs: {
                          "auto-size": { minRows: 3, maxRows: 5 },
                          placeholder: "请输入活动说明",
                          disabled: _vm.show,
                        },
                      }),
                    ],
                    1
                  ),
                ],
                1
              ),
            ],
            1
          ),
        ],
        1
      ),
      _c(
        "el-tabs",
        { staticClass: "tabsClass" },
        [
          _c(
            "el-tab-pane",
            { attrs: { label: "客户信息列表" } },
            [
              _c("clientList", {
                ref: "clientList",
                attrs: { rowId: _vm.rowId },
              }),
            ],
            1
          ),
          _c(
            "el-tab-pane",
            { attrs: { label: "现场照片" } },
            [
              _vm.typeDesc ? _c("p", [_vm._v(_vm._s(_vm.typeDesc))]) : _vm._e(),
              _c("liveFile", {
                ref: "liveFile",
                attrs: { fileList: _vm.liveFileList, rowId: _vm.rowId },
                on: { remove: _vm.removeLiveImg, change: _vm.changeLiveFile },
              }),
            ],
            1
          ),
          _c(
            "el-tab-pane",
            { attrs: { label: "费用信息列表" } },
            [
              _c("accountInfoList", {
                ref: "accountInfoList",
                attrs: { rowId: _vm.rowId },
                on: { changeSumCharge: _vm.changeSumCharge },
              }),
            ],
            1
          ),
        ],
        1
      ),
      _c(
        "a-space",
        { staticClass: "a-form-btn-box" },
        [
          _c(
            "a-button",
            {
              on: {
                click: function ($event) {
                  return _vm.endEdit("cancelled")
                },
              },
            },
            [_vm._v("取消")]
          ),
          _c(
            "a-button",
            {
              attrs: { type: "primary" },
              on: {
                click: function ($event) {
                  return _vm._save(false)
                },
              },
            },
            [_vm._v("提交")]
          ),
        ],
        1
      ),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }